import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

// SHER-564 — a single row of the prescription (ordonnance) drug search dropdown.
// Presentational only: it shows the drug name and, when the result comes from the
// investigation's own pharmacy stock (a type=PHARMACY billable) rather than the national
// formulary, a "Pharmacie" chip so the prescriber can tell what the hospital actually keeps.

export type DrugSource = 'catalogue' | 'pharmacy';

interface DrugResultOptionProps {
    name: string;
    source?: DrugSource;
    /** Translated label for the pharmacy-stock chip (defaults to "Pharmacie"). */
    pharmacyLabel?: string;
}

const DrugResultOption: React.FC<DrugResultOptionProps> = ({ name, source, pharmacyLabel = 'Pharmacie' }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
        <Typography variant="body2" sx={{ flex: 1 }}>{name}</Typography>
        {source === 'pharmacy' && (
            <Chip label={pharmacyLabel} size="small" color="secondary" variant="outlined" />
        )}
    </Box>
);

export default DrugResultOption;
